import Link from "next/link";
import styles from "./ErrorScreen.module.css";

export default function ErrorScreen() {
  return (
    <div className={styles.ErrorScreen}>
      <div>
        <p>Oops, we could not get what you&apos;re looking for. Sorry...</p>
        <p>
          <Link className="Button" href="/">
            Ok, just send me home again
          </Link>
        </p>
      </div>
    </div>
  );
}
